/** 头条/火山引擎站长平台「自动收录」push.js（每站唯一，从站长后台复制） */
const PUSH_SRC = (process.env.REACT_APP_TOUTIAO_PUSH_URL || "").trim();
let initialized = false;

export function isToutiaoAutoPushEnabled() {
  return Boolean(PUSH_SRC);
}

/** 用户访问页面时自动向头条搜索提交当前 URL */
export function initToutiaoAutoPush() {
  if (!PUSH_SRC || initialized || typeof window === "undefined") {
    return;
  }
  if (document.getElementById("ttzz")) {
    initialized = true;
    return;
  }

  const el = document.createElement("script");
  el.src = PUSH_SRC;
  el.id = "ttzz";
  el.async = true;
  const first = document.getElementsByTagName("script")[0];
  if (first?.parentNode) {
    first.parentNode.insertBefore(el, first);
  } else {
    document.head.appendChild(el);
  }
  initialized = true;
}
